<template>
  <div class="login-main">
    <nav-bar></nav-bar>
    <section class="orders-status-start">
      <div
        class="review-container review-main text-capitalize position-relative"
      >
        <div class="row">
          <div class="col-md-12 p-0">
            <div class="resturant-details plr15">
              <h4 class="text-left">{{ $t("My Bookings") }}</h4>
            </div>
            <div class="orders-tab-main reserve-orders plr15 mt-4">
              <template>
                <div id="ongoing" class="tab-pane active tab-box">
                  <div class="orders-lst skelton" v-if="is_skel_loader">
                    <a href="javascript:void(0);">
                      <div class="order-item d-flex align-items-start">
                        <div class="img-cls smallimg-squre">
                          <skeleton-loader-vue
                            width="85px"
                            height="85px"
                            style="border-radius: 5px"
                          />
                        </div>
                        <div
                          class="order-data ml-3 d-flex align-items-start justify-content-between w-100"
                        >
                          <div class="orders-status-main delivery-link">
                            <h6 class="mb-1">
                              <skeleton-loader-vue
                                type="string"
                                width="130px"
                                height="20px"
                              />
                            </h6>
                            <skeleton-loader-vue
                              type="string"
                              width="50px"
                              height="20px"
                            />
                            <p class="mt-2">
                              <skeleton-loader-vue
                                type="string"
                                width="100px"
                                height="20px"
                              />
                            </p>
                          </div>
                          <div class="order-status">
                            <p class="order-status-btn">
                              <skeleton-loader-vue
                                type="circle"
                                width="100px"
                                height="20px"
                                style="border-radius: 20px !important"
                              />
                            </p>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div
                    class="orders-lst"
                    v-if="bookingLists.length > 0 && !is_skel_loader"
                  >
                    <a
                      href="javascript:void(0)"
                      v-for="(order, index) in bookingLists"
                      :key="index"
                    >
                      <div class="order-item d-flex align-items-start">
                        <div class="img-cls smallimg-squre">
                          <img :src="order.icon_image" @error="imageErrorHandle"/>
                        </div>
                        <div
                          class="order-data ml-3 my-bookings d-flex align-items-start justify-content-between w-100"
                        >
                          <div class="on-going-order">
                            <div class="bok-slug">
                              <h6 class="mb-1">{{ order.name }}</h6>
                              <div
                                class="order-status"
                                v-if="order.status == 'Pending'"
                              >
                                <p class="readytoserve order-status-btn">
                                  {{ $t("Pending Confirmation") }}
                                </p>
                              </div>
                              <div
                                class="order-status"
                                v-else-if="order.status == 'InKitchen'"
                              >
                                <p class="readytoserve order-status-btn">
                                  {{ $t("Processing") }}
                                </p>
                              </div>
                              <div
                                class="order-status"
                                v-else-if="order.status == 'ReadyToServe'"
                              >
                                <p class="readytoserve order-status-btn">
                                  {{ $t("Food Ready") }}
                                </p>
                              </div>
                              <div
                                class="order-status"
                                v-else-if="order.status == 'OnTheWay'"
                              >
                                <p class="readytoserve order-status-btn">
                                  {{ $t("On The Way") }}
                                </p>
                              </div>
                              <div
                                class="order-status"
                                v-else-if="order.status == 'Expired'"
                              >
                                <p class="canceled order-status-btn">
                                  {{ $t("Expired") }}
                                </p>
                              </div>
                              <div
                                class="order-status"
                                v-else-if="order.status == 'Completed'"
                              >
                                <p class="delivered order-status-btn">
                                  {{ order.status }}
                                </p>
                              </div>
                              <div
                                class="order-status"
                                v-else-if="order.status == 'Rejected'"
                              >
                                <p class="canceled order-status-btn">
                                  {{ order.status }}
                                </p>
                              </div>
                            </div>
                            <p class="gest">
                              Number of Guests : {{ order.guests_count }}
                            </p>
                            <p class="bkid">Booking id : {{ order.id }}</p>
                            <p>
                              {{
                                moment(order.future_delivery_date).format(
                                  "DD-MM-YYYY h:mmA"
                                )
                              }}
                            </p>
                            <div class="menu-call">
                              <a
                                :href="order.dine_menu_link"
                                target="_blank"
                                class="menu-link mt-2"
                                >Menu</a
                              >
                              <a
                                :href="'tel:' + order.phone"
                                class="menu-link mt-2"
                                >Call Restaurant</a
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div v-else class="order-offers">
                    <p class="text-center ml-1">
                      {{ $t("No Ongoing Order Found") }}
                    </p>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </section>
  </div>
</template>
<script>
import NavBar from "@/components/NavBar.vue";
import Footer from "../components/Footer.vue";
import moment from "moment";
import VueSkeletonLoader from "skeleton-loader-vue";
import { mapActions, mapGetters } from "vuex";
import { imageErrorHandle } from "../helper/helper";

export default {
  components: { NavBar, Footer, "skeleton-loader-vue": VueSkeletonLoader },

  data() {
    return {
      imageErrorHandle:imageErrorHandle,
      bookingLists: [],
      moment: moment,
      is_skel_loader: true,
    };
  },

  mounted() {
    if (this.$auth.user) {
      this.bookingOrders();
    }
  },
  methods: {
    ...mapActions("order", ["OrderPreBookingList"]),
    bookingOrders() {
      this.is_skel_loader = true;
      this.OrderPreBookingList({
        vendor_id: this.$auth.getVendorId(),
        is_langauge: this.$store.state.lang.locale,
        user_id: this.$auth.user.user_id,
      }).then((data) => {
        if (data.code == 200) {
          this.is_skel_loader = false;
          this.bookingLists = data.Result;
        }
        if (data.code == 101) {
          this.is_skel_loader = false;
        }
      });
    },
  },
};
</script>
<style scoped>
.bok-slug {
  display: flex;
  justify-content: space-between;
}
.bok-slug h6 {
  font-size: 16px;
  margin-bottom: 0 !important;
}
p.gest {
  color: red;
  font-size: 14px;
}

.menu-call {
  display: flex;
  justify-content: space-between;
}
.order-item p {
  margin-bottom: 0;
  font-size: 14px;
}
</style>
